import React from "react";
import { useNavigate } from "react-router-dom";
import "./HeroSection.css";

// Poster Image
import heroPoster from "../../Assets/images/poster.jpg";

// Video
import heroVideo from "../../Assets/storyfest/storyfestvideo.mp4";

// 👇 IMPORT YOUR FLYER HERE
import storyfestFlyer from "../../Assets/storyfest/believe.png";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="ample-productions-hero-section">

      {/* Background Video */}
      <video
        className="ample-productions-hero-bg-video"
        autoPlay
        loop
        muted
        playsInline
        poster={heroPoster}
      >
        <source
          src={heroVideo}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="ample-productions-hero-overlay"></div>

      {/* Hero Content */}
      <div className="ample-productions-hero-content">

        {/* LEFT CONTENT */}
        <div className="ample-productions-hero-text">

          <span className="ample-productions-hero-label">
            AMPLE PRODUCTIONS
          </span>

          <h1 className="ample-productions-hero-title">
            Believe in something extraordinary
          </h1>

          <p className="ample-productions-hero-subtitle">
            A THREE-DAY FAMILY FESTIVAL
          </p>

          <p className="ample-productions-hero-description">
            This Christmas, experience an original theatrical journey filled with soul-stirring music, captivating storytelling, and the wonder and magic of believing.
          </p>

          <button 
            onClick={() => navigate('/believe')} 
            className="ample-productions-hero-btn"
          >
            Explore the Believe Experience<span className="ample-productions-btn-arrow">↗</span>
          </button>

        </div>

        {/* RIGHT FLYER */}
        <div className="ample-productions-hero-flyer-wrapper">
          <div className="ample-productions-hero-flyer-card">
            <img 
              src={storyfestFlyer} 
              alt="StoryFest 2026 Flyer" 
              className="ample-productions-hero-flyer-image" 
            />
          </div>
        </div>

      </div>

    </section>
  );
};

export default HeroSection;